module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-full relative flex flex-col space-y-1.5 pb-2.5 rounded px-3"
  }, [(_vm.getCurrentDiscussion.currently_active) ? _c('div', {
    staticClass: "w-10 h-10 flex items-center justify-center bg-lightBlue-200 rounded-full py-2 cursor-pointer relative overflow-visible",
    class: {
      'mt-9': _vm.isFullscreen
    }
  }, [_c('div', {
    staticClass: "w-7 relative h-7 rounded-full overflow-hidden speaking",
    on: {
      "click": function($event) {
        return _vm.handleOpenParticipantAssessment(_vm.currentSpeaker)
      }
    }
  }, [_c('img', {
    staticClass: "rounded-full",
    attrs: {
      "src": _vm.currentSpeaker.user.avatar_url
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', [_vm._l((_vm.usersInCircle), function(studentInCircle, index) {
    return _c('ul', {
      key: index
    }, [(studentInCircle.participation.user.id !== _vm.getCurrentDiscussion.currently_active) ? _c('li', {
      staticClass: "hover:bg-gray-200 cursor-pointer rounded-full w-10 h-10 flex items-center justify-center mb-1",
      attrs: {
        "title": studentInCircle.participation.user.name
      },
      on: {
        "click": function($event) {
          return _vm.openParticipantFromTapIn(studentInCircle.participation.user.id)
        },
        "mouseenter": function($event) {
          _vm.isHoveringStudent = studentInCircle.participation.user.id
        },
        "mouseleave": function($event) {
          _vm.isHoveringStudent = null
        }
      }
    }, [_c('div', {
      staticClass: "w-7 relative h-7 rounded-full ring-2 ring-yellow-400 ring-offset-2"
    }, [_c('img', {
      staticClass: "rounded-full",
      attrs: {
        "src": studentInCircle.participation.user.avatar_url
      }
    })])]) : _vm._e()])
  }), _vm._v(" "), _c('ul', {
    staticClass: "-mb-1"
  }, _vm._l((_vm.studentsFiltered), function(student, index) {
    return _c('li', {
      key: index
    }, [(_vm.isStudentOnline(student.user_id) && _vm.isStudentNotInCircle(student.user_id) && student.user_id !== _vm.getCurrentDiscussion.currently_active) ? _c('div', {
      staticClass: "py-2 hover:bg-gray-100 rounded-full px-2 cursor-pointer mb-1",
      attrs: {
        "title": student.user.name
      }
    }, [_c('div', {
      staticClass: "w-7 relative h-7 rounded-full ring-2 ring-green-600 ring-offset-2"
    }, [_c('img', {
      staticClass: "rounded-full",
      attrs: {
        "src": student.user.avatar_url
      }
    })])]) : _vm._e()])
  }), 0)], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-c8f128a4!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/liveDiscussion/components/Participants/ListParticipantsCollapsed.vue
// module id = 1887
// module chunks = 61